import { isString } from 'lodash/fp';
import { DateTimeLocalizationInfo } from '@mews-framework/globalization';
import { ISOFormat, LocalizationFormatName } from '../enums';
import { dateTimeFromFormat } from './dateTimeFromFormat';

export default function unformatLuxon(
    formatStringName: LocalizationFormatName,
    localizationInfo: DateTimeLocalizationInfo | ISOFormat,
    value: string,
    timezone?: string
) {
    // This is an edge case for when the provided localizationInfo is actually a format string. Will be fixed in the future.
    if (isString(localizationInfo)) {
        return dateTimeFromFormat(value, localizationInfo, { zone: timezone });
    }

    // formatDynamicDate helper for masked fields adds -normalized suffix to the culture code, and Luxon doesn't support it.
    const parsedCultureCode = localizationInfo.cultureCode.split('-normalized')[0];

    const formatString = localizationInfo[formatStringName];
    return dateTimeFromFormat(value, formatString, { zone: timezone, locale: parsedCultureCode });
}
